<template lang="pug">
// using a standard id for now as campaign-actions isn't fully done
span
  router-link(:to="{ name: 'campaigns-show', params: { id: this.data.id, name: this.item }}")
    | {{ this.item }}
  v-icon.ml-2(v-show='data.is_shared_by_broker' small) group
  div.shared(v-show="data.is_broker_sharing_on || data.id_drip_shared")
    v-icon.mr-1(small) share
    span {{ getSharedPublishText(data) }} 
</template>

<script>
import GetItem from '@/Core/mixins/getItem';

export default {
  mixins: [GetItem],
  computed: {
    id() {
      return this.data.id;
    },
  },
  methods: {
    getSharedPublishText(data) {
      if (data.is_shared_by_broker) {
        return 'Shared by your admin';
      }

      const SHARED = 'Shared with Sub-Account';
      const PUBLISHED = 'Published Campaign';
      const bothActive = data.is_broker_sharing_on && data.id_drip_shared;
      if (bothActive) {
        return `${SHARED} | ${PUBLISHED}`;
      }
      return data.is_broker_sharing_on ? SHARED : PUBLISHED;
    }
  },
  props: {
    data: {
      type: Object,
    },
    dataKey: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.shared span, .v-icon{
  color: var(--v-secondary-lighten3);
  font-size: 12px;
}
</style>
